import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Salesforcetemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Salesforce",
        content: [
        "Overview of Salesforce and its products",
        "Introduction to the Salesforce ecosystem",
        "Understanding the Salesforce architecture and data model",
        "Introduction to Salesforce Lightning Experience",
        "Setting up a Salesforce Developer Environment"
        ]
        },
        {
        title: "Salesforce Basics",
        content: [
        "Navigating Salesforce",
        "Managing users, profiles, and permissions",
        "Creating and managing objects, fields, and relationships",
        "Creating and managing records",
        "Building basic reports and dashboards"
        ]
        },
        {
        title: "Advanced Salesforce Development",
        content: [
        "Apex programming language",
        "Visualforce development",
        "Lightning Component Framework",
        "Building and deploying custom applications",
        "Integrating with external systems"
        ]
        },
        {
        title: "Salesforce Administration",
        content: [
        "Managing users and profiles",
        "Configuring security and access controls",
        "Data management and data quality",
        "Creating and managing workflows, approvals, and process builder",
        "Managing customizations, including apps, objects, fields, and layouts"
        ]
        },
        {
        title: "Salesforce Lightning Experience",
        content: [
        "Introduction to Lightning Experience",
        "Building Lightning pages and components",
        "Lightning App Builder",
        "Lightning Design System",
        "Migrating from Salesforce Classic to Lightning Experience"
        ]
        },
        {
        title: "Salesforce Integration",
        content: [
        "Understanding integration options",
        "REST and SOAP APIs",
        "Outbound messaging and Apex callouts",
        "Apex REST Services",
        "Integrating with third-party systems"
        ]
        },
        {
        title: "Salesforce Analytics",
        content: [
        "Introduction to Salesforce Analytics",
        "Creating and managing reports and dashboards",
        "Data analysis using SOQL and SOSL",
        "Einstein Analytics",
        "Integrating with external reporting tools"
        ]
        },
        {
        title: "Salesforce Mobile App Development",
        content: [
        "Introduction to Salesforce mobile app development",
        "Building custom mobile apps with Salesforce Mobile SDK",
        "Mobile App Management and Deployment",
        "Mobile Security and Identity Management",
        "Offline mobile app development"
        ]
        },
        {
        title: "Salesforce Marketing Cloud",
        content: [
        "Introduction to Salesforce Marketing Cloud",
        "Building and managing marketing campaigns",
        "Email marketing and Journey Builder",
        "Social media marketing",
        "Mobile marketing"
        ]
        },
        {
        title: "Salesforce Service Cloud",
        content: [
        "Introduction to Salesforce Service Cloud",
        "Case management and ticketing system",
        "Service Cloud Console",
        "Live Agent and Omni-Channel",
        "Field Service Lightning"
        ]
        },
        {
        title: "Salesforce Community Cloud",
        content: [
        "Introduction to Salesforce Community Cloud",
        "Building and managing online communities",
        "Customizing and branding community pages",
        "Community engagement and collaboration",
        "Community Cloud Security and Access"
        ]
        },
        {
        title: "Salesforce Advanced Topics",
        content: [
        "Governor Limits and Apex best practices",
        "Salesforce DX and Continuous Integration",
        "Salesforce Identity and Access Management",
        "Salesforce CPQ and Billing",
        "Salesforce Einstein Platform"
        ]
        }
    ]

    const faqData = [
      {
        question: 'How can sales courses impact organizational success?',
        answer:
          'Sales courses equip teams with strategies to drive revenue, improve customer satisfaction, and foster long-term business growth.',
      },
      {
        question: 'How do sales courses cater to both beginners and experienced professionals?',
        answer:
          'Sales courses offer foundational knowledge for beginners and advanced strategies for experienced professionals.',
      },
      {
        question: 'What types of organizations use Salesforce?',
        answer:
        "Organizations of all sizes and industries use Salesforce, including businesses, non-profits, government agencies, and educational institutions. Salesforce can be used for a variety of purposes, such as managing sales and marketing activities, providing customer service, and tracking donor relationships."    
      
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Career opportunities for someone with Salesforce skills may include roles such as Salesforce administrator, developer, consultant, or architect. These roles may involve tasks like configuring and customizing the platform, building applications and integrations, and advising on best practices and strategies for using Salesforce.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"learnsoft.org's Salesforce training eligibility requirements may include basic computer skills, understanding of Salesforce concepts, and possibly prerequisites for advanced courses. Technical background or experience in related fields can be beneficial. Educational background in areas like computer science or business administration may also be advantageous. Access to a Salesforce account for hands-on practice might be necessary. However, specific requirements may vary based on the course or certification level. For accurate and up-to-date information, it's best to review learnsoft.org's official documentation or contact their support team directly."
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the fast-paced world of business, forging and nurturing customer relationships is paramount. Enter Salesforce, a pioneering customer relationship management (CRM) tool that has become the cornerstone for sales, marketing, and support teams worldwide. With its innovative cloud-based services, Salesforce empowers businesses to seamlessly connect with potential customers and partners, revolutionizing how organizations approach customer engagement."/>
            */}
                                        
          <NewMainsec rating='4.1' students={"339"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the fast-paced world of business, forging and nurturing customer relationships is paramount. Enter Salesforce, a pioneering customer relationship management (CRM) tool that has become the cornerstone for sales, marketing, and support teams worldwide. With its innovative cloud-based services, Salesforce empowers businesses to seamlessly connect with potential customers and partners, revolutionizing how organizations approach customer engagement."/>
           
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Salesforce ${this.props.location1} is an in-demand field with a growing demand for professionals with Salesforce skills. At Learnsoft.org, we offer top-notch Salesforce training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Salesforce principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Salesforce or looking to expand your skillset, Learnsoft.org's Salesforce ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our Salesforce certification courses and start your journey in the world of Salesforce.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Salesforce course covers a wide range of topics, including Salesforce Administration, Salesforce Development, and Salesforce Lightning. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Salesforce. By the end of the course, you will be able to implement Salesforce practices in your own projects."} />
   </section>
 <Batchtime title={this.props.title} fees="30,999" offer="20,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="AWS DevOps" coupath7="aws-devops" cou='Azure DevOps' coupath='azure-devops' cou9='Azure Administration' coupath9='azure-admin' cou3='Azure' coupath3='azure' cou10='Azure Developer' coupath10='azure-developer'
          cou5='Salesforce Developer' coupath5='salesforce-developer' cou6='Jenkins' coupath6='jenkins' cou1='Salesforce administration' coupath1='salesforce-administration'
          cou8='Terraform' coupath8='terraform' cou2='DevOps' coupath2='devops'  cou4='Salesforce Architect' coupath4='salesforce-data-architect' />
          
      </>
    );
  }
}
